export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_16.189bc1b4.jpg";